<template>
  <section class="asc-page-error--section">
    <h1 class="asc-page-error--title">{{ title }}</h1>
    <asc-header
      class="asc-page-error--subtext"
      :color="color"
      size="h1"
      uppercase
      :value="subtext"
    />
    <slot></slot>
  </section>
</template>

<script>
import AscHeader from '@/components/atoms/AscHeader'
import variables from '@/styles/_varsJs.scss'
export default {
  name: 'AscPageErrorContent',

  components: {
    AscHeader,
  },

  props: {
    title: {
      type: String,
      default: '',
    },
    subtext: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      color: variables.gray500,
    }
  },
}
</script>

<style lang="scss">
.asc-page-error {
  &--heading {
    text-align: center;
    margin-bottom: 16px;
  }

  &--section {
    display: flex;
    width: 591px;
    height: 100%;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    background-color: $primary-white;
    justify-content: center;
  }
  &--subtext {
    align-self: stretch;
  }

  &--subtext > .asc-header--h1 {
    color: $gray-600;
    text-align: center;
    font-size: 34px;
    font-style: normal;
    font-weight: 400;
    line-height: 42px;
    letter-spacing: 4px;
  }

  &--title {
    align-self: stretch;
    color: $gray-300;
    text-align: center;
    font-size: 128px;
    font-style: normal;
    font-weight: 700;
    line-height: 150px;
    letter-spacing: 0;
  }
}

//mobile portrait & landscape
@media only screen and (max-width: 600px) and (orientation: portrait),
  only screen and (max-width: 960px) and (max-height: 600px) and (orientation: landscape) {
  .asc-page-error--section {
    width: 100%;
    padding: 0px 0px 30px 0px;
  }
}
</style>
